<template>
    <div class="user-info">
        <!--        <div class="navbar-wrapper">-->
        <!--            <Navbar />-->
        <!--        </div>-->

        <div class="main-content">
            <el-card class="info-card" shadow="always" style="width: 100%; min-height: 125px">
                <template #header>
                    <div class="card-header">
                        <span style="font-size: 20px; font-weight: 600">个人信息</span>
                    </div>
                </template>

                <el-row :gutter="20" class="info-content">
                    <el-col :span="12">
                        <div class="info-item">账号： {{ account }}</div>
                    </el-col>

                    <el-col :span="6">
                        <div class="info-item">降AI余额： {{ balance }}词</div>
                    </el-col>
                </el-row>
            </el-card>
            <el-card class="history-card" shadow="always" style="width: 100%; min-height: 450px">
                <template #header>
                    <div class="card-header">
                        <div class="header-content">
                            <span class="header-title">历史记录</span>
                            <span class="header-hint">(刷新页面查看结果)</span>
                        </div>
                        <div class="privacy-notice">
                            为保护用户隐私，请尽快下载报告，后台会不定时清理
                        </div>
                    </div>
                </template>

                <el-tabs v-model="activeHistoryCard" type="border-card">
                    <el-tab-pane label="降AI记录" name="weightLossHistory" style="font-weight: 100">
                        <div class="table-wrapper">
                            <el-table
                                :data="weightLossHistory"
                                :border="false"
                                :stripe="false"
                                style="width: 1100px"
                            >
                                <el-table-column label="输入内容" width="150">
                                    <template #default="scope">
                                        <a
                                            class="details-link"
                                            @click="showDetails(scope.row.input, '输入内容')"
                                            >点击查看</a
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="inputNumber"
                                    label="输入字数"
                                    width="100"
                                ></el-table-column>
                                <el-table-column label="输出内容" width="150">
                                    <template #default="scope">
                                        <a
                                            class="details-link"
                                            @click="showDetails(scope.row.showContent, '输出内容')"
                                            >点击查看</a
                                        >
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="showNumber"
                                    label="输出字数"
                                    width="100"
                                ></el-table-column>
                                <el-table-column
                                    prop="balance"
                                    label="余额"
                                    width="100"
                                ></el-table-column>
                                <el-table-column
                                    prop="score"
                                    label="得分"
                                    width="100"
                                ></el-table-column>
                                <el-table-column
                                    prop="createAt"
                                    label="生成时间"
                                    :formatter="dateTimeFormatterUTC"
                                    width="200"
                                ></el-table-column>
                                <el-table-column label="主页查看详情" width="200">
                                    <template #default="scope">
                                        <a
                                            class="details-link"
                                            @click="gotoHomepage(scope.row.id, '查看详情')"
                                            >点击查看</a
                                        >
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>

                        <el-pagination
                            background
                            @size-change="handleSizeChangeWeightLoss"
                            @current-change="handleCurrentChangeWeightLoss"
                            :current-page="currentPageWeightLoss"
                            :page-sizes="[5]"
                            :page-size="pageSizeWeightLoss"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCountWeightLoss"
                        />
                    </el-tab-pane>
                    <el-tab-pane label="查AI记录" name="plagiarismHistory" style="font-weight: 100">
                        <div class="table-wrapper">
                            <el-table
                                :data="plagiarismHistory"
                                :border="false"
                                :stripe="false"
                                style="width: 1100px"
                            >
                                <el-table-column label="ID" width="100">
                                    <template #default="scope">
                                        {{ getFileName(scope.row.reportId) }}
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="file_path"
                                    label="文件名"
                                    width="220"
                                    show-overflow-tooltip
                                >
                                    <template #default="scope">
                                        {{ getFileName(scope.row.filePath) }}
                                    </template>
                                </el-table-column>
                                <el-table-column label="状态" width="100">
                                    <template #default="scope">
                                        <el-tag :type="getStatusType(scope.row.status)">
                                            {{ getStatusText(scope.row.status) }}
                                        </el-tag>
                                    </template>
                                </el-table-column>
                                <el-table-column label="查重率" width="100">
                                    <template #default="scope">
                                        <span
                                            v-if="
                                                scope.row.similarityPercent !== null &&
                                                scope.row.similarityPercent !== undefined
                                            "
                                            >{{ scope.row.similarityPercent }}
                                        </span>
                                        <span v-else>—</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="AI率" width="100">
                                    <template #default="scope">
                                        <span
                                            v-if="
                                                scope.row.aiPercent !== null &&
                                                scope.row.aiPercent !== undefined
                                            "
                                            >{{ scope.row.aiPercent }}
                                        </span>
                                        <span v-else>—</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="查重报告" width="100">
                                    <template #default="scope">
                                        <a
                                            v-if="scope.row.plagiarismReportUrl"
                                            :href="scope.row.plagiarismReportUrl"
                                            target="_blank"
                                            class="details-link"
                                        >
                                            查看
                                        </a>
                                        <span v-else>—</span>
                                    </template>
                                </el-table-column>
                                <el-table-column label="AI报告" width="100">
                                    <template #default="scope">
                                        <a
                                            v-if="scope.row.aiReportUrl"
                                            :href="scope.row.aiReportUrl"
                                            target="_blank"
                                            class="details-link"
                                        >
                                            查看
                                        </a>
                                        <span v-else>—</span>
                                    </template>
                                </el-table-column>

                                <el-table-column label="源文件" width="100">
                                    <template #default="scope">
                                        <a
                                            v-if="scope.row.submittedFileUrl"
                                            :href="scope.row.submittedFileUrl"
                                            target="_blank"
                                            class="details-link"
                                        >
                                            查看
                                        </a>
                                        <span v-else>—</span>
                                    </template>
                                </el-table-column>
                                <el-table-column
                                    prop="createAt"
                                    label="创建时间"
                                    :formatter="dateTimeFormatter"
                                    width="180"
                                />
                            </el-table>
                        </div>
                        <el-pagination
                            background
                            @size-change="handleSizeChangePlagiarism"
                            @current-change="handleCurrentChangePlagiarism"
                            :current-page="currentPagePlagiarism"
                            :page-sizes="[5]"
                            :page-size="pageSizePlagiarism"
                            layout="total, sizes, prev, pager, next, jumper"
                            :total="totalCountPlagiarism"
                        />
                    </el-tab-pane>
                </el-tabs>
            </el-card>
            <DetailsWords
                v-model:visible="dialogVisible"
                :title="dialogTitle"
                :content="dialogContent"
            />
        </div>
    </div>
</template>

<script setup>
import { ref, onMounted } from 'vue'
import { apiService } from '@/api/Api.js'
import DetailsWords from '@/components/DetailsWords.vue'
import { alertService } from '@/utils/alertService.js'
import { useRouter } from 'vue-router'
import { formatTimeToMinuteUTC } from '@/utils/formatDateTime.js'
import store from '@/stores/store.js'
import { removeToken } from '@/stores/authStore'
import { getFileName, getStatusText, getStatusType } from '@/utils/plagiarismUtils.js'

const phone = ref()
const email = ref()
const account = ref()
const balance = ref()
const router = useRouter()
const activeHistoryCard = ref('weightLossHistory')

/* 获取用户信息 */
async function fetchDataUserInfo() {
    const requestParams = {}
    try {
        const response = await apiService.listUserInfo(requestParams)

        phone.value = response.data.userInfo.phone
        email.value = response.data.userInfo.email
        account.value = email.value || phone.value
        balance.value = response.data.userInfo.balance
    } catch (error) {
        // console.log(error)

        if (error.response?.data?.code === 401 || error.response?.data?.business_code === 10001) {
            removeToken()
            alertService.showError('用户未登录')
            // router.push('/login')
        } else {
            alertService.showError(error.response?.data?.message || '发生未知错误！')
        }
    }
}

/* 获取降AI历史记录 */
const currentPageWeightLoss = ref(1) // 当前页码
const pageSizeWeightLoss = ref(5) // 每页显示数量
const weightLossHistory = ref([])
const totalCountWeightLoss = ref(0) // 总条数
async function fetchDataWeightLossHistoryInfo() {
    const requestParams = {
        pageInfo: {
            pageSize: pageSizeWeightLoss.value,
            page: currentPageWeightLoss.value
        }
    }
    try {
        const response = await apiService.listWeightLossHistory(requestParams)
        // console.log(response)
        weightLossHistory.value = response.data.weightLossContent
        totalCountWeightLoss.value = Number(response.data.totalCount)
    } catch (error) {
        if (error.response?.data?.code === 401) {
            removeToken()
            alertService.showError('用户未登录')
            // router.push('/login')
        } else {
            alertService.showError(error.response?.data?.message || '发生未知错误！')
        }
    }
}
function handleCurrentChangeWeightLoss(newPage) {
    currentPageWeightLoss.value = newPage
    fetchDataWeightLossHistoryInfo() // 重新获取数据
}
// 当每页显示数量改变时的处理函数
function handleSizeChangeWeightLoss(newSize) {
    pageSizeWeightLoss.value = newSize
    fetchDataWeightLossHistoryInfo() // 重新获取数据
}

/* 获取查重历史记录 */
const currentPagePlagiarism = ref(1) // 当前页码
const pageSizePlagiarism = ref(5) // 每页显示数量
const plagiarismHistory = ref([])
const totalCountPlagiarism = ref(0) // 总条数
const fetchPlagiarismHistory = async () => {
    try {
        const requestParams = {
            pageInfo: {
                pageSize: pageSizePlagiarism.value,
                page: currentPagePlagiarism.value
            },
            orderBy: {
                field: 'create_at',
                desc: true
            }
        }

        const response = await apiService.listPlagiarismResult(requestParams)
        console.log('response:', response)
        plagiarismHistory.value = response.data.plagiarisms
        totalCountPlagiarism.value = Number(response.data.totalCount)
    } catch (error) {
        if (error.response?.data?.code === 401) {
            removeToken()
            alertService.showError('用户未登录')
            // router.push('/login')
        } else {
            alertService.showError(error.response?.data?.message || '发生未知错误！')
        }
    }
}
function handleCurrentChangePlagiarism(newPage) {
    currentPagePlagiarism.value = newPage
    fetchPlagiarismHistory() // 重新获取数据
}
// 当每页显示数量改变时的处理函数
function handleSizeChangePlagiarism(newSize) {
    pageSizePlagiarism.value = newSize
    fetchPlagiarismHistory() // 重新获取数据
}

/* 查看详情 */
const dialogVisible = ref(false)
const dialogTitle = ref('')
const dialogContent = ref('')
const showDetails = (content, title) => {
    dialogContent.value = content
    dialogTitle.value = title
    dialogVisible.value = true
}

const gotoHomepage = (contentId) => {
    store.commit('setContentId', contentId)
    router.push('/')
}

onMounted(() => {
    fetchDataUserInfo()
    fetchDataWeightLossHistoryInfo()
    fetchPlagiarismHistory()
})

const dateTimeFormatterUTC = (_row, _column, cellValue) => {
    return formatTimeToMinuteUTC(cellValue)
}
</script>

<style>
.user-info {
    display: flex;
    width: 100%;
    min-width: 1200px;
    overflow: hidden;
    min-height: 660px;
    .main-content {
        width: 1200px;
        display: flex;
        flex-direction: column;
        align-items: center;
        margin: 40px auto;
        padding: 0 20px;

        .info-card {
            width: 100%;
            min-height: 125px;
            .info-content {
                .info-item {
                    font-size: 16px;
                }
            }
        }

        .history-card {
            margin-top: 50px;
            margin-bottom: 40px;
            width: 100%;
            height: calc(53px * 5 + 200px); /* 表格行高 * 每页条数 + 其他元素高度 */

            .header-content {
                display: flex;
                align-items: center;
            }

            .header-title {
                font-size: 20px;
                font-weight: 600;
            }

            .header-hint {
                font-size: 14px;
                color: #909399;
                margin-left: 10px;
                font-weight: normal;
            }

            .privacy-notice {
                color: #ff0000;
                font-size: 14px;
                margin-top: 8px;
                font-weight: 500;
            }

            :deep(.el-card__body) {
                height: 100%;
            }

            :deep(.el-tabs) {
                height: 100%;
            }

            :deep(.el-tabs__content) {
                padding: 20px;
            }

            :deep(.el-tab-pane) {
                height: 100%;
            }

            .table-wrapper {
                margin-bottom: 20px;
            }

            :deep(.el-table) {
                width: 100%;
            }

            :deep(.el-table__row) {
                height: 53px; /* 设置表格行高 */
            }

            :deep(.el-pagination) {
                margin-top: 20px;
                padding: 10px 0;
            }
        }
    }
}

.details-link {
    color: #1e90ff;
    text-decoration: underline;
}
.details-link:hover {
    color: #104e8b;
    cursor: pointer;
}
</style>
